import {Request} from './Request';

export class RemoteStopTransactionRequest implements Request {
    chargePointSelectList: string[];
    private transactionId: string;

    constructor(chargePointSelectList: string[], transactionId?: string) {
        this.transactionId = transactionId;
        this.chargePointSelectList = chargePointSelectList;
    }

    public toString = (): string => {
        return `RemoteStopTransactionRequest (transactionId: ${this.transactionId},
        chargePointSelectList: ${this.chargePointSelectList})`;
    }

    get transaction_d(): string {
        return this.transactionId;
    }

    set transaction_d(value: string) {
        this.transactionId = value;
    }
}
